"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const CatalogCompactWorkItem_1 = __importDefault(require("@Components/WorkItemV2/Catalog/CatalogCompactWorkItem"));
const mobx_react_1 = require("mobx-react");
const contexts_1 = require("@App/contexts");
const PointPreloader_1 = __importDefault(require("@Components/Preloaders/PointPreloader"));
const SearchWithCriteria_1 = __importDefault(require("@Components/Search/SearchWithCriteria"));
const CardResults_1 = __importDefault(require("@Components/CardResults"));
const uuid_1 = require("uuid");
const CatalogExtendedWorkItem_1 = __importDefault(require("@Components/WorkItemV2/Catalog/CatalogExtendedWorkItem"));
const work_registration_forms_1 = require("@Const/work-registration-forms");
const CreateWorkManualWorkSearch = () => {
    var _a, _b, _c;
    const { createWorkSearchStore, workStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const [hasSearched, setHasSearched] = (0, react_1.useState)(false);
    const [loading, setLoading] = (0, react_1.useState)(false);
    const workItemDataList = ((_b = (_a = createWorkSearchStore.createWorkSearchResults) === null || _a === void 0 ? void 0 : _a.works) === null || _b === void 0 ? void 0 : _b.map((work) => ({
        work,
        handleOnClick: (selectedWork) => {
            createWorkSearchStore.setRedirectingToCatalog(true);
        },
        getId: () => work.id || (0, uuid_1.v4)(),
        displayType: 'public',
    }))) || [];
    const showLoadingWithAwaiting = (cb) => __awaiter(void 0, void 0, void 0, function* () {
        setLoading(true);
        yield cb();
        setLoading(false);
    });
    (0, react_1.useEffect)(() => {
        if (Object.keys(createWorkSearchStore.createWorkSearchQuery).length !== 0) {
            setHasSearched(true);
        }
        return () => {
            createWorkSearchStore.resetWorkRegistrationSearchCriteriaIfNeeded();
        };
    }, []);
    return (react_1.default.createElement("div", { className: "content-container" },
        createWorkSearchStore.searchCriteriaStore && (react_1.default.createElement(SearchWithCriteria_1.default, { searchCriteriaStore: createWorkSearchStore.searchCriteriaStore, handleSearch: (submittedSearchCriteria) => {
                var _a;
                setLoading(true);
                setHasSearched(true);
                const workDraft = work_registration_forms_1.CLEAR_WORK_DRAFT;
                workDraft.title = (_a = submittedSearchCriteria.title) !== null && _a !== void 0 ? _a : '';
                workStore.setWorkDraftToLocal(workDraft);
                createWorkSearchStore.setCreateWorkSearchQuery(submittedSearchCriteria);
                createWorkSearchStore.searchForWorks().finally(() => setLoading(false));
            }, resetSearchFn: () => createWorkSearchStore.resetWorkRegistrationSearchCriteriaIfNeeded(), disableSearchButtons: loading, canAddCriteria: true })),
        react_1.default.createElement("div", { className: "search-list" },
            react_1.default.createElement("div", { className: "found-items-wrapper" }, loading ? (react_1.default.createElement(PointPreloader_1.default, null)) : (hasSearched && (react_1.default.createElement(CardResults_1.default, { data: workItemDataList, count: ((_c = createWorkSearchStore.createWorkSearchResults) === null || _c === void 0 ? void 0 : _c.count) || 0, limit: createWorkSearchStore.currentResultsPerPageLimit, paginationInfo: createWorkSearchStore.createWorkSearchPaginationInfo, compactCardType: CatalogCompactWorkItem_1.default, extendedCardType: CatalogExtendedWorkItem_1.default, compact: true, onChangePage: (pagination) => __awaiter(void 0, void 0, void 0, function* () {
                    createWorkSearchStore.setCurrentPage(pagination.page ? pagination.page : 1);
                    yield showLoadingWithAwaiting(() => createWorkSearchStore.searchForWorks(pagination));
                }), onChangeLimit: (newLimit) => __awaiter(void 0, void 0, void 0, function* () {
                    yield showLoadingWithAwaiting(() => createWorkSearchStore.onChangeLimit(newLimit));
                }), numTitlesProps: createWorkSearchStore.numTitles, outerDivClassName: 'individual-registration-work-results-table' })))))));
};
exports.default = (0, mobx_react_1.observer)(CreateWorkManualWorkSearch);
